import React from 'react'
import tw, { styled } from 'twin.macro'

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  message: string
  variant?: 'filled' | 'outlined'
  customTw?: string
  size?: 'large' | 'medium' | 'small'
  full?: boolean
}

const sizeMap = {
  large: tw`w-4/5`,
  small: `width: 225px; height: 60px;`,
  medium: tw`max-w-64 w-full h-14 sm:max-w-72 sm:h-16`,
}

const ButtonBase = styled.button`
  ${tw`transition-all duration-150 rounded-full font-bold uppercase ease-linear
  focus:outline-none outline-none text-sm sm:text-lg md:text-xl whitespace-pre-line
  px-20`}
  ${sizeMap.small}
  ${
    // @ts-ignore
    ({ size }) => sizeMap[size]
  }
  ${
    // @ts-ignore
    ({ full }) => (full ? tw`xs:max-w-none sm:max-w-none` : '')
  }
`

const FilledButton = styled(ButtonBase)`
  ${tw`bg-white text-green-300 active:bg-gray-50
  shadow-md hover:shadow-lg hover:bg-gray-100 hover:text-green-400`}
`

const OutlineButton = styled(ButtonBase)`
  ${tw`text-green-500 bg-transparent border border-solid border-green-500
  hover:bg-green-500 hover:text-white active:bg-green-600 mr-1 mb-1 `}
`

const Button: React.FC<ButtonProps> = ({
  onClick,
  message,
  variant = 'filled',
  size = 'medium',
  full = false,
}) => {
  if (variant === 'filled') {
    return (
      // @ts-ignore
      <FilledButton size={size} onClick={onClick} full={full}>
        {message}
      </FilledButton>
    )
  }

  return (
    // @ts-ignore
    <OutlineButton size={size} onClick={onClick} full={full}>
      {message}
    </OutlineButton>
  )
}

export default Button
